import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { gsap } from "gsap";
// import { SplitText } from "gsap/SplitText";

@Component({
  selector: 'app-christmas-hero-spot',
  templateUrl: './christmas-hero-spot.component.html',
  styleUrls: ['./christmas-hero-spot.component.scss']
})
export class ChristmasHeroSpotComponent implements OnInit {


  private router: Router;

  constructor(router: Router) { this.router = router }

  public ngOnInit(): void
  {
    this.animateHeader();
  }

  public animateHeader(): void
  {
    var tl = gsap.timeline({repeat: -1, repeatDelay: 3});
    
    var mySplitChar = new SplitText("#splitit", {type:"chars"})
      var chars = mySplitChar.chars;

    gsap.set("#splitit", {perspective: 500});
  
    tl.add("start");
    
    tl.from("#anim-container", {autoAlpha: 0})
    tl.from(chars, {
		duration: 0.5, 
		opacity:0, 
		scale:1.5, 
		y:150, 
		rotationX:10, 
		transformOrigin:"0% 50% 50%",  
    rotate: 50,
		ease: "back.out(3)",
		stagger: 0.05,
	}, "+=0.3")
  .from(".bg-pynt",{autoAlpha:0}, "-=0.3")
  .from(".sub", {autoAlpha: 0, ease: "power4.in"}, "-=0.5")
  .to("#splitit", {delay: 2, opacity: 0, ease: "power4.out"}, ">")
  .to(".sub", {opacity: 0, ease: "power4.out"}, "<")
  .to(".bg-pynt",{opacity: 0, ease: "power4.out"}, "<")
  .from("g", {
      duration: 1,
      autoAlpha: 0,
      scale: 0,
      rotation: 90, 
      transformOrigin: "50% 50%", 
      stagger: 0.03,
      ease: "elastic.out(0.5,0.4)",
    }, "-=0.5")
  .from("#kal-pynt", {
      duration: 0.5,
      transformOrigin:"50% 50%", 
      autoAlpha: 0,
      scale: 0, 
      stagger: 0.05,
      ease: "elastic.out(1,0.4)"}, "-=0.5")
    ;
  
     console.log(tl.duration());

  }

  public _pulse(elem) {
    var tl = gsap.timeline({ delay: 2, repeat: 3, repeatDelay: 0.2 });
    tl.to(elem, 0.3, { scale: 1.3, ease: Back.easeIn })
      .to(elem, 0.3, { scale: 1, ease: Back.easeOut.config(0.3) });
    return tl
  }

  public showPage(): void
  {
    window.location.href = 'https://julekalender.klasselotteriet.dk/?nocache=true';
  }

  public navigateToSubPage(path: string): void
  {
      this.router.navigateByUrl(path);
  }
}
